export default "__VITE_ASSET__3251c45a__"